export default __webpack_public_path__ + "static/media/icon-cadenas.69b53a18.svg";